import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import { mainColor } from '../../constants';

// Définir les types de props avec TypeScript
interface SpinnerProps {
  size?: number;
  style?: React.CSSProperties;
}

const Spinner: React.FC<SpinnerProps> = ({ size = 40, style }) => {
  return (
    <CircularProgress
      style={{
        color: mainColor.secondaryColor,
        ...style
      }}
      size={size}
    />
  );
};

export default Spinner;
